import React, {Component} from 'react'
import './trackInfo.less'
import {
    Row,
    Col,
    Steps,
    message,
    Table,
    Tabs,
    Button,
    Timeline
} from 'antd'
import {ReactBingmaps} from 'react-bingmaps'
import DeliveryStep from '../../components/step/delivery-step'
import {getOrderTrails, getOrderShort, baseUrl} from '../../api'
import {splitStr} from '../../utills/subStringUtill'
import axios from 'axios'
import authorizeBase from "../../components/authorize/authorizeBase";
const AuthButton = authorizeBase(Button)
const { TabPane } = Tabs;
const {Step} = Steps;
let orderId;
class TrackInfo extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isVisible: true,
            test: "1234",
            bingmapKey: "AuXjIRtmvSChnWxFOVerDnOU8EZyQ-LXI-w9zsxkmEYFR9DmScWoZFM88YcTw6uv",
            center: [],
            dataSource: [],
            rowId: 1,
            order: {

            },
            boxNo:'',
            carNo:'',
            factoryNo:'',
            currentStep: 0,
            destinationCity: '',
            mapData: [],
            stepDescription:[],
        }
    }

    getOrderShortFunc = async (id) => {
        let result = await getOrderShort(id)
        if (result.code === 200) {
            var data = result.data;
            data.start = data.originCountry +' '+ data.originCity;
            data.destination = data.destinationCountry+' '+ data.destinationCity;
            this.setState({
                order: data,
                destinationCity: '到达' + data.destinationCity,
                commitDt: data.commitDt
            })
        } else if (result.code === 401) {
            this.props.history.replace('/login')
        } else {
            message.error(result.message)
        }
    }

    componentWillMount() {
        if (this.props.location.state) {
            orderId = this.props.location.state.orderId;
        }

        this.getOrderShortFunc(orderId);

        const timer_two = (record) => setTimeout(
            () => {
                this.getOrderTrails(record)
                this.getRightOrderTrails(record)
            },
            2000
        );

        axios.get(baseUrl + '/api/v1/p/orderDelivery', { // 配置对象
            params: {orderId} // 指定请求参数
        }).then((res) => {
            var result = res.data;
            if (result.code === 200) {
                // debugger
                if (result.data && result.data.length > 0) {
                    const data = [];
                    let boxNo = '';
                    let factoryNo = '';
                    for (let i = 0; i < result.data.length; i++) {
                        result.data[i].id = i+1;
                        result.data[i].key = i;
                        var tempData = result.data[i];
                        tempData.key=i;
                        tempData.rowId=i+1;
                        data.push(result.data[i]);
                        if (result.data[i].boxNo) { //箱号
                            boxNo = boxNo + result.data[i].boxNo + '，';
                        }
                        if (result.data[i].factoryNo) { //厂封号
                            factoryNo = factoryNo + result.data[i].factoryNo + '，';
                        }
                        if (i===1 && i < result.data.length - 1) {
                            boxNo = boxNo+'...';
                            factoryNo = factoryNo+'...';
                            break;
                        }
                    }
                    boxNo =splitStr(boxNo)
                    factoryNo =splitStr(factoryNo)

                    // debugger
                    this.setState({
                        dataSource: data,
                        boxNo: boxNo,
                        factoryNo: factoryNo,
                        mapData:result.data
                    })
                    // this.getOrderTrails(data[0].trailNo)
                    timer_two(data[0].trailNo)
                    this.getRightOrderTrails(data[0].trailNo)
                }
            } else {
                message.error(result.message)
                return false;
            }
        });

        axios.get(baseUrl + '/api/v1/p/orderVehicle', { // 配置对象
            params: {orderId} // 指定请求参数
        }).then((res) => {
            var result = res.data;
            if (result.code === 200) {
                // debugger
                if (result.data && result.data.length > 0) {
                    let carNo = '';
                    for (let i = 0; i < result.data.length; i++) {
                        if (result.data[i].truckNo) { //车牌号
                            carNo = carNo + result.data[i].truckNo + '，';
                        }
                        if (i===1 && i < result.data.length - 1) {
                            carNo = carNo+'...';
                            break;
                        }
                    }
                    carNo =splitStr(carNo)
                    this.setState({
                        carNo: carNo,
                    })
                }
            } else {
                message.error(result.message)
                return false;
            }
        });
    }

    scrollInto=(id)=>{
        let anchorElement = document.getElementById(id);
        if(anchorElement) {
            this.setState({
                activeId:id,
            })
            anchorElement.scrollIntoView({block: "start", inline: "start"});
        }else{
           // console.log(id+" not found")
        }
    }

    getOrderTrails = async (trailNo) => {
        if (trailNo) {
            let result = await getOrderTrails({trailNo,type:'normal',orderId})
            if (result.code === 200 && result.data.length > 0) {
                let ret = []
                let ret2 = []
                result.data.forEach( (item)=> {
                    let address =
                        '位置:'+ item.address  + '<br/>' +
                        '设备号:'+ item.trailNo + '<br/>' +
                        '到达时间:'+ item.activeDt  + '<br/>' +
                        '纬度:'+ item.latitude + '<br/>' +
                        '经度:'+ item.longitude + '<br/>' +
                        '温度(摄氏):'+ item.uTemperature + '<br/>' +
                        '电量(%):'+ item.uBattery + '<br/>' +
                        '信号强度:'+ item.uSignalstrength;
                    ret.push({
                        "location": [item.latitude, item.longitude],
                        "addHandler": "mouseover",
                        "infoboxOption": {title: "", description: address, maxHeight: 300, maxWidth: 420},
                        "pushPinOption": {title: "", description: "", color: 'DodgerBlue'},
                        "infoboxAddHandler": {"type" : "click", callback: ()=>{this.scrollInto("step"+item.id)} },
                        "pushPinAddHandler": {"type" : "click", callback: ()=>{this.scrollInto("step"+item.id)} }
                    })
                    ret2.push([item.latitude, item.longitude])
                });
                this.setState({
                    center: ret2[0],
                    infoboxesWithPushPins: ret,
                    polyline: {"location": ret2, "option": {strokeColor: 'DodgerBlue', strokeThickness: 4}},
                });
            } else if (result.code === 200){
                this.setState({
                    center: [],
                    infoboxesWithPushPins: [],
                    polyline:{"location": [], "option": {strokeColor: '', strokeThickness: 0}},
                });
            } else {
                message.error(result.message)
            }
        }
    }

    exportModel = () => {
         let orderNo = this.state.order.orderNo
         window.location.href=baseUrl + "//api/v1/p/oms/opt/export?orderNo="+orderNo;
    }

    getRightOrderTrails= async (trailNo) => {
        if (trailNo) {
            let result = await getOrderTrails({trailNo,type:'all',orderId})
            if (result.code === 200 && result.data.length > 0) {
                let description = []
                result.data.forEach(function (item) {
                    let sesObj = {
                        id:item.id,
                        sts:item.sts,
                        activeDt:item.activeDt,
                        address:item.address,
                        latitude:item.latitude,
                        longitude:item.longitude,
                        uTemperature:item.uTemperature,
                        uSignalstrength:item.uSignalstrength

                    }
                    description.push(sesObj)
                });
                this.setState({
                    stepDescription:description
                });
            } else if (result.code === 200){
                this.setState({
                    stepDescription:[]
                });
            } else {
                message.error(result.message)
            }
        }
    }

    tabChange = (key) =>{
        this.getOrderTrails(key)
        this.getRightOrderTrails(key)
    }
    steDescription = (obj) => {
        if(obj){
            return <div>
                <div>{obj.activeDt}</div>
                <div>{obj.address}</div>
                <div>经度:{obj.latitude}</div>
                <div>纬度:{obj.longitude}</div>
                <div>温度(摄氏):{obj.uTemperature}</div>
                <div>信号强度:{obj.uSignalstrength}</div>
            </div>
        }

    }

    setColletDt = (date) =>{
        if(date){
            this.setState({
                collectDt:date
            })
        }

    }
    render() {
        const {stepDescription,mapData} = this.state
        return (
            <div className='trackInfo'>
                <div className="track-info-details box-shadow margin-bootom">
                    <Row className='track-info-item'>
                        <Col span={6}>
                            <span className='label'>订单编号 : </span>
                            <span>{this.state.order.orderNo}</span>
                        </Col>
                        <Col span={6}>
                            <span className='label'>起运地 : </span>
                            <span>{this.state.order.start}</span>
                        </Col>
                        <Col span={6}>
                            <span className='label'>目的地 : </span>
                            <span>{this.state.order.destination}</span>
                        </Col>
                        <Col span={6}>
                            <span className='label'>收货人 : </span>
                            <span>{this.state.order.consignee}</span>
                        </Col>

                    </Row>
                    <Row className='track-info-item'>
                        <Col span={6}>
                            <span className='label'>提货时间 : </span>
                            <span>{this.state.collectDt}</span>
                        </Col>
                        <Col span={6}>
                            <span className='label'>车牌号 : </span>
                            <span>{this.state.carNo}</span>
                        </Col>
                        <Col span={6}>
                            <span className='label'>集装箱号 ：</span>
                            <span>{this.state.boxNo}</span>
                        </Col>
                        <Col span={6}>
                            <span className='label'>厂封号 ：</span>
                            <span>{this.state.factoryNo}</span>
                        </Col>
                    </Row>
                </div>
                <div className='box-shadow padding-20'>
                    <AuthButton type='primary' authority="delivery_edit:trail_export" style={{float:"right"}} onClick={this.exportModel}>导出</AuthButton>
                    <div className='tract-step-info '>
                        <DeliveryStep {...this.props} setColletDt={this.setColletDt}/>
                    </div>
                    {
                        mapData? <Tabs  type="card" style={{marginTop:'10px'}} onChange={this.tabChange}>
                            {mapData.map(t => (
                                <TabPane tab={t.trailNo} key={t.trailNo}>
                                </TabPane>
                            ))}
                        </Tabs>:null
                    }
                    <div className='track-map-box '>
                        <div className="track-step-map" id="bingmap">
                            <ReactBingmaps
                                //center = {[13.0827, 80.2707]}
                                zoom={8}
                                center={this.state.center}
                                bingmapKey={this.state.bingmapKey}
                                polyline={this.state.polyline}
                                infoboxesWithPushPins={this.state.infoboxesWithPushPins}
                            >
                            </ReactBingmaps>
                        </div>
                        <div className='track-map-list'>
                            {stepDescription ? <Timeline>
                                {stepDescription.map(des => (
                                    <Timeline.Item id={"step"+des.id} key={"step"+des.id}><p style={this.state.activeId === ("step"+des.id)?{color:"#2975d5",paddingTop:3}:(des.sts !== 'N'?{color:"rgba(0, 0, 0, 0.9)",paddingTop:3}:{color:"rgba(0,0,0,.45)",paddingTop:3})}>{this.steDescription(des)}</p></Timeline.Item>
                                ))}
                            </Timeline> : null}
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
export default TrackInfo
